/* import { useParams } from 'react-router-dom'; */
import '../../../index.css';
import EligeProfesionEditar from '../../../components/bodyBlocks/profesionalBlock/editarProfesional/EligeProfesionEditar';



const EditProfesional = () => {
  return (
    <div>
      <EligeProfesionEditar />
    </div>
  );
};

export default EditProfesional
